<template>
  <div class="animated fadeIn col-md-12 px-0">
    <div class="text-center" v-if="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <div v-if="!isLoading">
      <b-card border-variant="default" :no-body="false">
        <Search
          ref="searchVotes"
          :title="$lang.finalReportVoteSearchTitle"
          :url="url"
          :allowFields="$lang.final_report_votes_fields"
          :dynamicButtons="buttons"
          :hiddenFields="hiddenFields"
          :remove_item="remove_item"
          addModalSize="md"
          removeModalSize="md"
          @getPermisson="getPermissions"
          :visibleAdd="isAdmin(permissions, ['admin'])"
        >
          <template slot="addModal" slot-scope="search">
            <AddVotes
              :query="$route.query"
              @closeModal="search.close"
              @getData="getData"
            />
          </template>
        </Search>
      </b-card>
    </div>
    <Confirm
      :title="$lang.final_report_remove_title"
      :description="$lang.are_you_sure_to_remove_item"
      v-model="removemodal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="confirmedRemoveItem"
      @cancel="notConfirmedRemoveItem"
    />
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_add"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <EditVotes
        :query="$route.query"
        :itemId="itemId"
        @closeModal="closeModal"
        @getData="getData"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import Confirm from "@/components/base/confirm";
import AddVotes from "./addVotes";
import EditVotes from "./editVotes";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  inject: ["finalReportVotesRepository"],
  components: {
    Search,
    Confirm,
    AddVotes,
    EditVotes,
  },
  data() {
    return {
      code: this.$route.params.code,
      removemodal: false,
      itemId: null,
      hiddenFields: [],
      isLoading: false,
      view_add: false,
      buttons: [
        {
          id: "0",
          name: "edit",
          click: this.modalEdit,
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      permissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["report", "final_report_votes"], [this.code]);
    },
  },
  methods: {
    isAdmin,
    generateApiUrl,
    notConfirmedRemoveItem() {
      this.removemodal = false;
    },
    async confirmedRemoveItem(number) {
      try {
        const response = await this.finalReportVotesRepository.delete(
          this.code,
          this.id
        );
        this.$notify.success(response.data.message);
        this.getData();
      } catch (error) {
        this.$generateError(error);
      }
    },
    closeModal() {
      this.view_add = false;
    },
    getData() {
      this.view_add = false;
      this.$refs.searchVotes.getItems();
    },
    modalEdit(item) {
      this.itemId = item.id;
      this.view_add = true;
    },
    async remove_item(item) {
      try {
        let response = await this.finalReportVotesRepository.delete(
          this.code,
          item.id
        );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    getPermissions(permissions) {
      this.permissions = permissions;
    },
  },
};
</script>

